<template>
  <div>
    <v-snackbar v-model="snackbar.active" style="margin-top: 60px;" timeout="5000"
                :color="snackbar.color" :top="true" :right="true">
      {{snackbar.message}}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    snackbar: Object
  }
}
</script>